
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[eventId]/attend",
      function () {
        return require("private-next-pages/event/[eventId]/attend.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[eventId]/attend"])
      });
    }
  